import React, { useCallback, useEffect, useMemo, useState } from 'react'
import axios from 'axios'
import './UsuariosAdmin.css'

const USER_TYPES = [
    'comum',
    'fiscal',
    'fiscalAssessor',
    'coordenacao',
    'coordenacao_pb',
    'presidencia',
    'vice-presidencia',
    'defis',
    'interno'
]

const INITIAL_FORM = {
    nome: '',
    email: '',
    matricula: '',
    password: '',
    repeatPassword: '',
    tipo: 'comum',
    profissao: '',
    restrito: 'nao',
    estado: ''
}

const INITIAL_PASSWORD_FORM = {
    password: '',
    repeatPassword: ''
}

const cx = (...parts) => parts.filter(Boolean).join(' ')

const normalizeError = error => {
    if (error?.response?.data?.msg) return error.response.data.msg
    if (typeof error?.response?.data === 'string') return error.response.data
    return 'Não foi possível concluir a operação.'
}

function StatusMessage({ feedback, onClose }) {
    if (!feedback) return null

    return (
        <div className={cx('usuariosAdminFeedback', `usuariosAdminFeedback${feedback.type}`)}>
            <span>{feedback.message}</span>
            <button type="button" onClick={onClose} aria-label="Fechar mensagem">×</button>
        </div>
    )
}

function UsuarioModal({
    open,
    mode,
    form,
    onChange,
    onClose,
    onSubmit,
    submitting,
    error
}) {
    if (!open) return null

    const isCreate = mode === 'create'

    return (
        <div className="usuariosAdminModalOverlay" role="presentation">
            <div className="usuariosAdminModalCard" role="dialog" aria-modal="true" aria-labelledby="usuario-modal-title">
                <div className="usuariosAdminModalHeader">
                    <div>
                        <h2 id="usuario-modal-title">{isCreate ? 'Novo Usuário' : 'Editar Usuário'}</h2>
                        <p>{isCreate ? 'Preencha os dados para cadastrar um novo usuário.' : 'Atualize os dados cadastrais do usuário selecionado.'}</p>
                    </div>
                    <button type="button" className="usuariosAdminModalClose" onClick={onClose} disabled={submitting}>×</button>
                </div>

                <form className="usuariosAdminForm" onSubmit={onSubmit}>
                    <div className="usuariosAdminGrid usuariosAdminGridTwo">
                        <label>
                            <span>Nome *</span>
                            <input name="nome" value={form.nome} onChange={onChange} disabled={submitting} />
                        </label>
                        <label>
                            <span>Email *</span>
                            <input name="email" type="email" value={form.email} onChange={onChange} disabled={submitting} />
                        </label>
                        <label>
                            <span>Matrícula *</span>
                            <input name="matricula" value={form.matricula} onChange={onChange} disabled={submitting} />
                        </label>
                        <label>
                            <span>Tipo *</span>
                            <select name="tipo" value={form.tipo} onChange={onChange} disabled={submitting}>
                                {USER_TYPES.map(tipo => (
                                    <option key={tipo} value={tipo}>{tipo}</option>
                                ))}
                            </select>
                        </label>
                        <label>
                            <span>Profissão</span>
                            <input name="profissao" value={form.profissao || ''} onChange={onChange} disabled={submitting} />
                        </label>
                        <label>
                            <span>Restrito</span>
                            <select name="restrito" value={form.restrito || 'nao'} onChange={onChange} disabled={submitting}>
                                <option value="nao">Não</option>
                                <option value="sim">Sim</option>
                            </select>
                        </label>
                        <label className="usuariosAdminGridSpanTwo">
                            <span>Estado</span>
                            <input name="estado" value={form.estado || ''} onChange={onChange} disabled={submitting} />
                        </label>
                        {isCreate ? (
                            <>
                                <label>
                                    <span>Senha *</span>
                                    <input name="password" type="password" value={form.password} onChange={onChange} disabled={submitting} />
                                </label>
                                <label>
                                    <span>Repetir senha *</span>
                                    <input name="repeatPassword" type="password" value={form.repeatPassword} onChange={onChange} disabled={submitting} />
                                </label>
                            </>
                        ) : null}
                    </div>

                    {error ? <div className="usuariosAdminFormError">{error}</div> : null}

                    <div className="usuariosAdminModalActions">
                        <button type="button" className="usuariosAdminButton usuariosAdminButtonGhost" onClick={onClose} disabled={submitting}>Cancelar</button>
                        <button type="submit" className="usuariosAdminButton" disabled={submitting}>
                            {submitting ? 'Salvando...' : isCreate ? 'Cadastrar usuário' : 'Salvar alterações'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

function PasswordModal({ open, form, onChange, onClose, onSubmit, submitting, error, user }) {
    if (!open) return null

    return (
        <div className="usuariosAdminModalOverlay" role="presentation">
            <div className="usuariosAdminModalCard usuariosAdminModalCardSmall" role="dialog" aria-modal="true" aria-labelledby="usuario-password-modal-title">
                <div className="usuariosAdminModalHeader">
                    <div>
                        <h2 id="usuario-password-modal-title">Redefinir Senha</h2>
                        <p>{user ? `Defina uma nova senha para ${user.nome}.` : 'Defina a nova senha do usuário.'}</p>
                    </div>
                    <button type="button" className="usuariosAdminModalClose" onClick={onClose} disabled={submitting}>×</button>
                </div>

                <form className="usuariosAdminForm" onSubmit={onSubmit}>
                    <div className="usuariosAdminGrid">
                        <label>
                            <span>Nova senha *</span>
                            <input name="password" type="password" value={form.password} onChange={onChange} disabled={submitting} />
                        </label>
                        <label>
                            <span>Repetir nova senha *</span>
                            <input name="repeatPassword" type="password" value={form.repeatPassword} onChange={onChange} disabled={submitting} />
                        </label>
                    </div>

                    {error ? <div className="usuariosAdminFormError">{error}</div> : null}

                    <div className="usuariosAdminModalActions">
                        <button type="button" className="usuariosAdminButton usuariosAdminButtonGhost" onClick={onClose} disabled={submitting}>Cancelar</button>
                        <button type="submit" className="usuariosAdminButton" disabled={submitting}>
                            {submitting ? 'Atualizando...' : 'Atualizar senha'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default function UsuariosAdmin() {
    const isInterno = typeof window !== 'undefined' && localStorage.tipo === 'interno'
    const [usuarios, setUsuarios] = useState([])
    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [feedback, setFeedback] = useState(null)
    const [search, setSearch] = useState('')
    const [tipoFiltro, setTipoFiltro] = useState('')
    const [modalMode, setModalMode] = useState(null)
    const [modalError, setModalError] = useState('')
    const [senhaError, setSenhaError] = useState('')
    const [selectedUser, setSelectedUser] = useState(null)
    const [form, setForm] = useState(INITIAL_FORM)
    const [passwordForm, setPasswordForm] = useState(INITIAL_PASSWORD_FORM)

    const closeFeedback = () => setFeedback(null)

    const loadUsuarios = useCallback(async () => {
        setLoading(true)
        try {
            const response = await axios.get('/api/user/admin/list')
            setUsuarios(Array.isArray(response.data) ? response.data : [])
        } catch (error) {
            setFeedback({ type: 'error', message: normalizeError(error) })
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        if (!isInterno) {
            setLoading(false)
            return
        }

        loadUsuarios()
    }, [isInterno, loadUsuarios])

    const resetModalState = () => {
        setModalMode(null)
        setSelectedUser(null)
        setForm(INITIAL_FORM)
        setModalError('')
    }

    const resetPasswordState = () => {
        setSelectedUser(null)
        setPasswordForm(INITIAL_PASSWORD_FORM)
        setSenhaError('')
    }

    const openCreateModal = () => {
        setModalError('')
        setForm(INITIAL_FORM)
        setModalMode('create')
    }

    const openEditModal = user => {
        setModalError('')
        setSelectedUser(user)
        setForm({
            nome: user.nome || '',
            email: user.email || '',
            matricula: user.matricula || '',
            password: '',
            repeatPassword: '',
            tipo: user.tipo || 'comum',
            profissao: user.profissao || '',
            restrito: user.restrito || 'nao',
            estado: user.estado || ''
        })
        setModalMode('edit')
    }

    const openPasswordModal = user => {
        setSelectedUser(user)
        setPasswordForm(INITIAL_PASSWORD_FORM)
        setSenhaError('')
    }

    const handleFormChange = event => {
        const { name, value } = event.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const handlePasswordChange = event => {
        const { name, value } = event.target
        setPasswordForm(prev => ({ ...prev, [name]: value }))
    }

    const validateUserForm = () => {
        if (!form.nome.trim()) return 'O nome é obrigatório.'
        if (!form.email.trim()) return 'O email é obrigatório.'
        if (!form.matricula.trim()) return 'A matrícula é obrigatória.'
        if (!form.tipo.trim()) return 'O tipo é obrigatório.'

        if (modalMode === 'create') {
            if (!form.password || form.password.length < 6) return 'A senha deve possuir ao menos 6 caracteres.'
            if (form.password !== form.repeatPassword) return 'As senhas não conferem.'
        }

        return ''
    }

    const validatePasswordForm = () => {
        if (!passwordForm.password || passwordForm.password.length < 6) return 'A nova senha deve possuir ao menos 6 caracteres.'
        if (passwordForm.password !== passwordForm.repeatPassword) return 'As senhas não conferem.'
        return ''
    }

    const handleSubmitUsuario = async event => {
        event.preventDefault()
        const validationMessage = validateUserForm()
        if (validationMessage) {
            setModalError(validationMessage)
            return
        }

        setSubmitting(true)
        setModalError('')

        try {
            if (modalMode === 'create') {
                await axios.post('/api/user/admin/create', form)
                setFeedback({ type: 'success', message: 'Usuário cadastrado com sucesso.' })
            } else if (selectedUser?._id) {
                await axios.put(`/api/user/admin/${selectedUser._id}`, {
                    nome: form.nome,
                    email: form.email,
                    matricula: form.matricula,
                    tipo: form.tipo,
                    profissao: form.profissao,
                    restrito: form.restrito,
                    estado: form.estado
                })
                setFeedback({ type: 'success', message: 'Usuário atualizado com sucesso.' })
            }

            resetModalState()
            await loadUsuarios()
        } catch (error) {
            setModalError(normalizeError(error))
        } finally {
            setSubmitting(false)
        }
    }

    const handleSubmitPassword = async event => {
        event.preventDefault()
        const validationMessage = validatePasswordForm()
        if (validationMessage) {
            setSenhaError(validationMessage)
            return
        }

        setSubmitting(true)
        setSenhaError('')

        try {
            await axios.put(`/api/user/admin/${selectedUser._id}/password`, passwordForm)
            setFeedback({ type: 'success', message: 'Senha redefinida com sucesso.' })
            resetPasswordState()
            await loadUsuarios()
        } catch (error) {
            setSenhaError(normalizeError(error))
        } finally {
            setSubmitting(false)
        }
    }

    const handleSearch = async event => {
        event.preventDefault()
        if (!isInterno) return

        setLoading(true)
        closeFeedback()
        try {
            const hasFilters = search.trim() || tipoFiltro
            if (!hasFilters) {
                await loadUsuarios()
                return
            }

            const response = await axios.get('/api/user/admin/search', {
                params: {
                    q: search.trim(),
                    tipo: tipoFiltro
                }
            })

            setUsuarios(Array.isArray(response.data) ? response.data : [])
        } catch (error) {
            setFeedback({ type: 'error', message: normalizeError(error) })
        } finally {
            setLoading(false)
        }
    }

    const limparFiltros = async () => {
        setSearch('')
        setTipoFiltro('')
        closeFeedback()
        await loadUsuarios()
    }

    const tabelaVazia = useMemo(() => !loading && usuarios.length === 0, [loading, usuarios.length])

    if (!isInterno) {
        return (
            <div className="usuariosAdminPage">
                <div className="usuariosAdminRestricted">
                    <h1>Administração de Usuários</h1>
                    <p>Esta área é exclusiva para usuários internos.</p>
                </div>
            </div>
        )
    }

    return (
        <div className="usuariosAdminPage">
            <div className="usuariosAdminHeader">
                <div>
                    <span className="usuariosAdminEyebrow">Área interna</span>
                    <h1>Administração de Usuários</h1>
                    <p>Gerencie usuários, dados cadastrais e redefinição administrativa de senhas.</p>
                </div>
                <button type="button" className="usuariosAdminButton" onClick={openCreateModal} disabled={submitting}>
                    Novo Usuário
                </button>
            </div>

            <StatusMessage feedback={feedback} onClose={closeFeedback} />

            <div className="usuariosAdminToolbar">
                <form className="usuariosAdminFilters" onSubmit={handleSearch}>
                    <label className="usuariosAdminSearchField">
                        <span>Busca</span>
                        <input
                            type="text"
                            value={search}
                            onChange={event => setSearch(event.target.value)}
                            placeholder="Busque por nome, matrícula ou email"
                            disabled={loading}
                        />
                    </label>

                    <label>
                        <span>Tipo</span>
                        <select value={tipoFiltro} onChange={event => setTipoFiltro(event.target.value)} disabled={loading}>
                            <option value="">Todos</option>
                            {USER_TYPES.map(tipo => (
                                <option key={tipo} value={tipo}>{tipo}</option>
                            ))}
                        </select>
                    </label>

                    <div className="usuariosAdminFilterActions">
                        <button type="submit" className="usuariosAdminButton" disabled={loading}>Buscar</button>
                        <button type="button" className="usuariosAdminButton usuariosAdminButtonGhost" onClick={limparFiltros} disabled={loading}>Limpar</button>
                    </div>
                </form>
            </div>

            <div className="usuariosAdminTableWrapper">
                {loading ? (
                    <div className="usuariosAdminLoading">Carregando usuários...</div>
                ) : (
                    <table className="usuariosAdminTable">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Matrícula</th>
                                <th>Email</th>
                                <th>Tipo</th>
                                <th>Profissão</th>
                                <th>Restrito</th>
                                <th>Estado</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {usuarios.map(user => (
                                <tr key={user._id}>
                                    <td>{user.nome || '-'}</td>
                                    <td>{user.matricula || '-'}</td>
                                    <td>{user.email || '-'}</td>
                                    <td>{user.tipo || '-'}</td>
                                    <td>{user.profissao || '-'}</td>
                                    <td>{user.restrito || '-'}</td>
                                    <td>{user.estado || '-'}</td>
                                    <td>
                                        <div className="usuariosAdminActions">
                                            <button type="button" className="usuariosAdminActionButton" onClick={() => openEditModal(user)}>
                                                Editar
                                            </button>
                                            <button type="button" className="usuariosAdminActionButton usuariosAdminActionButtonSecondary" onClick={() => openPasswordModal(user)}>
                                                Senha
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {tabelaVazia ? <div className="usuariosAdminEmpty">Nenhum usuário encontrado para os filtros informados.</div> : null}
            </div>

            <UsuarioModal
                open={modalMode === 'create' || modalMode === 'edit'}
                mode={modalMode}
                form={form}
                onChange={handleFormChange}
                onClose={resetModalState}
                onSubmit={handleSubmitUsuario}
                submitting={submitting}
                error={modalError}
            />

            <PasswordModal
                open={!!selectedUser && !modalMode}
                form={passwordForm}
                onChange={handlePasswordChange}
                onClose={resetPasswordState}
                onSubmit={handleSubmitPassword}
                submitting={submitting}
                error={senhaError}
                user={selectedUser}
            />
        </div>
    )
}
